/*
 *
 * TODO: Roboto importot kiszeni a sassokból
 */

import * as modernizr from 'modernizr';
import WebFont from 'webfontloader';
WebFont.load({google: {families: ['Roboto:400,300,500:latin']}});

class engine_core {

   constructor(fn) {
      this.fn = fn
      this.shown = new this.shown
      this.result = false;
      /**
       * dataLayer létrehozása a Google tagManagerId miatt
       */
      window.dataLayer = window.dataLayer || [];
   }

   func(a) {
      this.a = {};
      if (!('log' in a)) a.log = true;
      const log = (a, msg) => {
         if (a.log) log({
               msg: msg ? msg : a.msg + ' missing fn:' + a.fn
            }
            );
         else console.log('!! hiányzó függvény (' + msg ? msg : a.msg + '): ' + a.fn);
      }

      if (typeof a.fn == 'number') {
         a.fnid = a.fn;
         a.fn = engine.fnmap[a.fn];
      }

      switch (typeof a.fn) {
         case 'function':
            this.valid = true;
            break;
         case 'undefined':
            log(a, 'undefined');
            this.valid = false;
            break;
         case 'string':
            if (a.fn.indexOf('#') == 0) {
               this.ret = eval(a.fn.substring(1));
               this.valid = false; //  már lefutott a fg
               break;
            }
            if (!$.isFunction(engine.fn[a.fn])) {
               log(a);
               this.valid = false;
               break;
            }
            a.fn = engine.fn[a.fn];
            this.valid = true;
            break;
         default:
            this.log(a, 'getFunc typeof: ' + typeof a.fn);
            this.valid = false;
            break;
      }
      this.a = a;

      this.call = function () {
         if (!this.valid) return null;
         var ra = [];
         if (this.a.fnid && typeof this.a.row != 'undefined') {
            var d = engine.row[this.a.row.data('id')];
            if (typeof d.args != 'undefined' && typeof d.args[this.a.fnid] != 'undefined') {
               ra = d.args[this.a.fnid];
               $.each(d.args[this.a.fnid], function (i, arg) {
                  ra[i] = decodeURIComponent(arg).replace(/\\/g, '\\\\');
               });
            }
         }
         return this.a.fn.apply(this.a, Array.prototype.slice.call(arguments).concat(ra));
      }
   }

   initRows() {
      console.time("initRows");
      console.groupCollapsed('initRows');
      this.settings.doInit = true;
      let self = this;
      $.each(engine.row, function (id, data) {
         var key = engine.rowmap[id];
         var row = $(engine.settings.form.id + ' .rows div#tb_' + key + '.row');
         row.off();
         row.on('rowError', data, self.rowHandler);
         console.log('field:', key, id, data.type, data);
         if (typeof data.init != 'undefined') {
            $.each(data.init, function (i, fnid) {
               new self.func({
                  fn: fnid,
                  msg: 'initRows'
               }).call(row);
            });
         }
         if (data.type == 'date') {
            console.log('dátum típus adatok:', data);
            var i = row.find('input');
            console.log(data.dp, engine.settings.dp);
            if (data.dp) {
               self.date();
               if (engine.settings.dp) {
                  if ('focusout' in data.events) {
                     data.events.onselect = data.events.focusout;
                     data.events.focusout = {};
                  }
                  i.prop('type', 'text').datepicker(data.dp);
                  i.prop('maxlength', '10');
                  console.log('dp>!>', i.val(), data.dp);
               } else {
                  i.val(i.val().replace(/\//g, '-'));
                  i.prop('type', 'date');
               }
            }
         }
         if (typeof data.events != 'undefined') {
            row.on(data.events.bind, data, engine.rowHandler);
            //changenek a selecten kell lennie
            if (data.type == 'select' && 'change' in data.events) {
               $(engine.settings.form.id + ' .rows div#tb_' + key + '.row select').on('change', data, engine.rowHandler);
            }
         }
         if (data.f.length) {
            row.showError(data.f);
         }
      });
      if (engine.shown != null && typeof engine.shown.i != 'undefined') {
         $.each(engine.shown.i, function (id, d) {
            engine.shown.process(id);
         });
      }

      engine.settings.doInit = false;
      console.groupEnd();
      console.timeEnd("initRows");
   }

   rowHandler(e, arg) {
      var row = $(e.currentTarget);
      if (!engine.settings.oSel && e.type == 'rowError') return row.showError(arg);
      if (engine.settings.oSel && e.type == 'focusout') return; // új ablak nyílik
      if ($(e.target).hasClass('help')) return;
      $.each(e.data.events[e.type], function (k, fnid) {
         if (!row.hasClass('row')) {
            // ha mélyebbről jön az event nincs dataset
            console.log('stop!', e);
            e.preventDefault();
            return;
         }
         if (new engine.func({
            fn: fnid,
            msg: 'rowHandler ' + e.type,
            log: e.type != 'focusout',
            row: row
         }).call(e) === false) {
            row.showError('inv');
            return false;
         }
      });
   }

   parseCommads() {
      if (typeof window.eCom != 'string') return;
      var c = JSON.parse(window.eCom);
      console.log('----- RECEIVED COMMANDS', c);
      $.extend(engine, c.engine);
      this.shown.setData(c.shown);
      window.eCom = null;
   }

   getMsg(type, id) {
      if (id in this[type]) return this[type][id];
      $.ajax({
         async: false,
         success: function (d) {
            if (typeof d == 'undefined' || d == null || !d.msg) return;
            engine[type][id] = d.msg.replace(/\n/g, "<br>");
         },
         data: {e: engine.settings.engine, wm: engine.settings.wm, s: engine.settings.s, id: id, op: type}
      });
      return this[type][id] || '';
   }
   getData(id) {
      if (id in this.sData) return this.sData[id];
      $.ajax({
         async: false,
         success: function (d) {
            if (typeof d == 'undefined' || d == null || !d.data) return;
            engine.sData[id] = d.data;
         },
         data: {s: engine.settings.s, id: id, op: 'data'}
      });
      return this.sData[id] || '';
   }

   ajaxFunc(f, a, as, s) {
      as = as || false;
      var ret;
      $.ajax({
         async: as,
         success: function (d) {
            if (typeof s == 'function') return s(d);
            ret = d;
         },
         data: {s: engine.settings.s, fn: f, op: 'fn', a: a}
      });
      return ret;
   }

   loadPopup(e, ui) {
      var t = $(e.target);
      if (t.data().role != 'popup') return;
      if (t.hasClass('help_data')) {
         if (t.html() != '') return;
         var h = "<a href='#' data-rel='back' class='ui-btn ui-corner-all ui-btn-a ui-icon-delete ui-btn-icon-notext ui-btn-right'>bezár</a>";
         h += this.getData(t.data('helpId'));
         console.log('data_id', t.data('helpId'));
         var docs = engine.ajaxFunc('get_docs_list', {id : t.data('helpId')});
         h += docs.value;
         t.html(h);
         engine.resizePageToPopup(t.parent());
         return;
      }
      if (t.hasClass('fn_data')) {
         var r = engine.ajaxFunc(t.data('fn'));
         var h = r.html;
         delete(r.html);
         var fn = r.fn;
         delete(r.fn);
         if (typeof fn != 'undefined') {
            new this.func({
               fn: fn,
               msg: 'loadPopup'
            }).call(r);
         }
         t.html(h).trigger('create');
         engine.resizePageToPopup(t.parent());
      }
   }
   // popupot használd helyette
   popDialog(msg, ok, ell, t, c) { //message, ok gomb, nem ok gomb, header szöveg, class
      if(msg == null || msg == '') popMsg(''); 

      var d = $('#dialog');
      if (!$('#dialog').length) {
         d =
            $("<div data-role='popup' id='dialog'><div data-role='header'><h2></h2></div><div role='main' class='ui-content'></div><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-check ui-btn-icon-right ok'></div><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-arrow-l ui-btn-icon-left ell'></div></div>"); // <a role='button' href='#' class='ui-btn ui-corner-all ui-icon-delete ui-btn-icon-notext ui-btn-right'>Bezár</a>
//            $("<div data-role='header'><h2></h2></div><div role='main' class='ui-content'></div><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-check ui-btn-icon-right ok'></div><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-arrow-l ui-btn-icon-left ell'></div>");
//         $('body').append(d);
      }
      if (typeof t == 'undefined') t = 'Figyelmeztetés!';
      d.find('h2').html(t);
      d.find('.ui-content').html(msg);
      if (ell) d.find('.ell').html(ell);
      if (ok) d.find('.ok').html(ok);

      console.log('dialog', d.html());
      engine.popMsg(d.html());
      if (c) d.addClass(c);

      $('#pop_msg').on('click', '.ell', function (e) {
         $('#pop_msg').popup('close');
      });
      $('#pop_msg').on('click', '.ok', function (e) {
         $(engine.settings.form.id).trigger('submit');
      });
   }

   getVal(type, wr) {
      switch (type) {
         case 'select':
         case 'mcheck':
         case 'flipswitch':
            return wr.find('select').val();
         case 'checkbox':
            return wr.find('input:checkbox').prop('checked') ? 1 : 0;
         case 'checkboxes':
            ret = {};
            $.each(wr.find('input:checkbox'), function () {
               var t = $(this), v;
               if (v = t.prop('checked')) ret[t.val()] = v ? 1 : 0;
            });
            return ret;
         case 'radio':
            return wr.find('input:radio:checked').val();
         case 'date':
            var d = $.trim(wr.find('input').val()).replace(/-/g, '/');
            d = d.split('/');
            return {y: +d[0], m: +d[1], d: +d[2] + 0};
            /*
             switch (engine.row[row.data('id')].show) {
             case 111:
             d = d.split('/');
             return {y: +d[0], m: +d[1], d: +d[2] + 0};
             case 100:
             return {y: +d};
             }
             */
            break;
         case 'readonly':
            return wr.find('.ro').data('value');
            break;
         default:
            var e, ret;
            e = wr.find('input,textarea');
            if (e.length == 1) return $.trim(e.val());
            ret = {};
            $.each(e, function () {
               var t = $(this), v;
               if (v = $.trim(t.val())) ret[t.prop('id')] = v;
            });
            return ret;
      }
   }
   shown() {
      this.setData = (d) => {
         this.d = d.d;
         this.i = d.i;
      }
      this.process = (id) => {
         this.v = {};
         // console.log('do ' + id, this.i[id]);
         $.each(this.i[id], function (k, did) {
            var d = engine.shown.d[did];
            d.v = {};
            $.each(d.fs, function (n, vf) {
               d.v[n] = engine.shown.getVal(vf);
               //               console.log('v', d, n, vf, engine.rowmap[vf], d.v[n]);
            });
            var row = $(engine.settings.form.id + ' .rows div#tb_' + engine.rowmap[d.f] + '.row');
            if (!row.length) {
               log({msg: 'shown term', f: engine.rowmap[d.f]});
               return;
            }
            if (eval('(' + d.t + ')')) row.showRow();
            else row.hideRow();
         });
      }
      this.getVal = (id) => {
         if (this.v[id]) return this.v[id];
         return this.v[id] = $('#tb_' + engine.rowmap[id]).rVal();
      }


   }
   popMsg(h, id) {
      if (id) var p = $('#' + id);
      else var p = $('#pop_msg');
      if (p.parent().hasClass('ui-popup-active')){
          p.popup('close');
      }
      if (h == null || h == '') return;
      setTimeout(function () {
         p.html(h).popup('open');
         engine.resizePageToPopup(p.parent());
      }, 400);
   }

   resizePageToPopup(p){
      //console.log(p);
      var page = $('.ui-panel-wrapper');
      if(typeof p !=='object'){
          page[0].style.height = '';
          return;
      }
      var pageHeight = Math.max(page[0].clientHeight, page[0].scrollHeight, page[0].offsetHeight);
      var popupHeight = Math.max(p[0].clientHeight, p[0].scrollHeight, p[0].offsetHeight);
      //console.log('popupHeight: '+popupHeight+' pageHeight: '+pageHeight);
      if(popupHeight > pageHeight){
          page[0].style.height = (popupHeight+20)+"px";
      }
   }

   date() {
      if (engine.settings.dp > -1) return;
      engine.settings.dp = (!modernizr.touchevents || !modernizr.inputtypes.date) ? 1 : 0;
      if (!engine.settings.dp && navigator.userAgent.toLowerCase().indexOf('firefox') > -1) engine.settings.dp = 1;
      if (!engine.settings.dp) return;
      let self = this;
      $.datepicker.regional['hu'] = {
         onClose: (dateText, inst) => {
            var row = inst.input.closest('.row');

            if (typeof engine.row[row.data('id')] == 'undefined') return;
            var d = engine.row[row.data('id')];

            if (typeof d.events == 'undefined'
                || typeof d.events.onselect == 'undefined') return;
            var s = d.events.onselect;

            $.each(s, function (k, fnid) {
               var e = {};
               e.currentTarget = row;
               if (new self.func({
                  fn: fnid,
                  msg: 'onClose',
                  row: row
               }).call(e)) {
                  row.showError('inv');
                  return false;
               }
            })
         },
         closeText: 'bezárás',
         prevText: '&laquo;&nbsp;vissza',
         nextText: 'előre&nbsp;&raquo;',
         currentText: 'ma',
         monthNames: ['Január', 'Február', 'Március', 'Április', 'Május', 'Június', 'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'],
         monthNamesShort: ['Jan', 'Feb', 'Már', 'Ápr', 'Máj', 'Jún', 'Júl', 'Aug', 'Szep', 'Okt', 'Nov', 'Dec'],
         dayNames: ['Vasánap', 'Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat'],
         dayNamesShort: ['Vas', 'Hét', 'Ked', 'Sze', 'Csü', 'Pén', 'Szo'],
         dayNamesMin: ['V', 'H', 'K', 'Sze', 'Cs', 'P', 'Szo'],
         firstDay: 1,
         changeMonth: true,
         changeYear: true,
         isRTL: false,
         showAnim: "fadeIn"};
      $.datepicker.setDefaults($.datepicker.regional['hu']);
   }

   basket_change(){
       var r = engine.ajaxFunc('Basket', {});
       $('div#cartBox').replaceWith(r.html);
   }
}

export default engine_core